import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbModule } from 'xng-breadcrumb';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.css'],
  standalone: true,
  imports: [BreadcrumbModule, RouterLink]
})
export class AccessDeniedComponent implements OnInit {
  @Input() showMenuBar: boolean = false;
  @Input() showMenuTitle!: string;

  constructor() {}

  ngOnInit(): void {}
}
